export default __webpack_public_path__ + "static/media/home-5-slider-image-3.97073be7.jpg";